/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Title_FallbackInputs */



/**
* | output |
* | --- |
* | "League" |
*
* @param {League_Title_FallbackInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_title_fallback = /** @type {((inputs?: League_Title_FallbackInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Title_FallbackInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campionato")
	return /** @type {LocalizedString} */ ("League")
});